import Nullstack from 'nullstack';
export default function IconBrandBlender({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-blender",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("ellipse", {
    cx: "15",
    cy: "14",
    rx: "6",
    ry: "5"
  }), "   ", Nullstack.element("circle", {
    cx: "15",
    cy: "14",
    r: "1"
  }), "   ", Nullstack.element("path", {
    d: "M3 16l9 -6.5"
  }), "   ", Nullstack.element("path", {
    d: "M6 9h9"
  }), "   ", Nullstack.element("path", {
    d: "M13 5l5.65 5"
  }), " ");
}